import { NumeralThousandsGroupStyleType } from "cleave.js/options";

export enum CreditCardProcessStatus {
    NotStarted,
    InProcesses,
    Finished
}

export interface CreditCardFSProcess {
    prossesingStatus: CreditCardProcessStatus,
    success: boolean,
    storedCreditCards: CreditCardModel[],
    storedCreditCardsLoaded: boolean,
    error: string,
    authKey: string,
    hostedFormURL: string,
    receiptLink: string
}

export interface AuthKeyReponse {
    authenticationKey: string,
    hostedPaymentURL:string
    // expirationDateUtc:string
}


export const initialValueAuthKeyReponse = {
    authenticationKey: '',
    expirationDateUtc: ''
}


export const CreditCardProcessIntialState: CreditCardFSProcess = {
    prossesingStatus: CreditCardProcessStatus.NotStarted,
    success: false,
    storedCreditCards: [],
    storedCreditCardsLoaded: false,
    error: '',
    authKey: '',
    hostedFormURL: '',
    receiptLink:''

};

export interface ChargeInvoicesModel {
    invoices: CreditCardARInvoice[],
    creditCardInfo: CreditCardModel,
    companyCode: string,
    entityType: string,
    entityCode: string
}

export interface CreditCardModel {
    sequence: number,
    cardHolderName: string,
    cardType: string,
    last4digits: string,
    cardExpiryMonth: string,
    cardExpiryYear: string,    
    avsZip: string,
    avsStreet: string,
    /*customer: CreditCardCustomerModel   */ 
}

export interface CreditCardARInvoice  {
    paymentStatus: string,
    autCode: string,
    aRNum: string,
    toBeProcessed: boolean,
    address: string,
    email: string,
    result: string,
    amountToCharge: number,
    balance: number,
    invoiceAmount: number,
    aRName: string,
    sMName: string,
    invoiceNumber: string,
    companyCode: string,
    invoiceDate: string,
}

export const initialState: CreditCardModel = {
    sequence: 0,
    cardHolderName: '',
    cardType:'',
    last4digits: '',
    cardExpiryMonth: '',
    cardExpiryYear: '',
    avsZip: '',
    avsStreet: '',
};

export const initialStateCargeModel: ChargeInvoicesModel = {
    invoices: [],  
    creditCardInfo: { ...initialState },    
    entityCode: '',
    entityType: '',
    companyCode: ''

}

export const initialStateCreditCardARInvoice: CreditCardARInvoice = {
    paymentStatus: '',
    autCode: '',
    aRNum: '',
    toBeProcessed:true,
    address: '',
    email: '',
    result: '',
    amountToCharge: 0,
    balance: 0,
    invoiceAmount: 0,
    aRName: '',
    sMName: '',
    invoiceNumber: '',
    companyCode: '',
    invoiceDate: ''
};

export interface CreditCardCustomerModel {
    name: string,
    email: string
}


export interface ChargeWithTokenMultipleRecordsPayload {
companyCode: string,
    sequence: number,
    billTo: string,
    amountToCharge: number,
    userNumber: string,
    userName: string,
    sendReceiptToEmail: string,
    sendReceiptToPhone: string,
    userType: string,
    transactionFee: number,
    comments: string,
    newCardToken: string,
    invoices: ChargeWithTokenInvoice[]
}

export const initialStateChargeWithTokenMultipleRecordsPayload: ChargeWithTokenMultipleRecordsPayload = {
    companyCode: '',
    sequence: -1,
    billTo: '',
    amountToCharge: 0,
    userNumber: '',
    userName: '',
    sendReceiptToEmail: '',
    sendReceiptToPhone: '',
    userType: '',
    transactionFee: 0,
    comments: '',
    newCardToken: '',
    invoices: []
}

export interface ChargeWithNewCardMultipleRecordsPayload {
    companyCode: string,
    newCardToken: string,
    newCardName: string,
    newCardLast4: string,
    billTo: string,
    amountToCharge: number,
    userNumber: string,
    userName: string,
    sendReceiptToEmail: string,
    sendReceiptToPhone: string,
    userType: string,
    transactionFee: number,
    comments: string,    
    invoices: ChargeWithTokenInvoice[]
}


export const initialStateChargeWithNewCardMultipleRecordsPayload: ChargeWithNewCardMultipleRecordsPayload = {
    companyCode: '',
    newCardToken: '',
    newCardName: '',
    newCardLast4: '',
    billTo: '',
    amountToCharge: 0,
    userNumber: '',
    userName: '',
    sendReceiptToEmail: '',
    sendReceiptToPhone: '',
    userType: '',
    transactionFee: 0,
    comments: '',
    invoices: []
}


export interface ChargeWithTokenInvoice {
    module: string,
    invoiceNum: string,
    amount: number
}

export interface ChargeWithTokenResult {
    success: boolean,
    authCode: string,
    transactionId: number,
    status: string,
    errors: string,
    receiptLink: string;
    
}

export const intialValueChargeWithTokenResult = {
    success: false,
    authCode: '',
    transactionId: 0,
    status: false,
    errors: ''
}